(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-search-drawer-script]");
  const src = loader?.dataset.searchDrawerScript;
  let readyPromise;
  let pendingTrigger = null;

  const isReady = () => customElements.get("search-drawer");
  const isScriptLoaded = (script) =>
    script.dataset.loaderReady === "true" ||
    script.readyState === "complete" ||
    script.readyState === "loaded" ||
    performance
      .getEntriesByName(script.src, "resource")
      .some((entry) => entry.responseEnd > 0);

  const load = () => {
    if (isReady() || !src) return Promise.resolve();
    if (readyPromise) return readyPromise;

    const stylesReady = window.loadSearchIdleStyles?.() || Promise.resolve();

    const scriptReady = new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts).find(
        (script) => script.src === src,
      );
      if (existing) {
        if (isScriptLoaded(existing)) {
          existing.dataset.loaderReady = "true";
          resolve();
          return;
        }
        existing.addEventListener("load", () => {
          existing.dataset.loaderReady = "true";
          resolve();
        }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.addEventListener("load", () => {
        script.dataset.loaderReady = "true";
        resolve();
      }, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });

    readyPromise = Promise.all([stylesReady, scriptReady])
      .then(() => customElements.whenDefined("search-drawer"))
      .catch((error) => {
        readyPromise = null;
        throw error;
      });

    return readyPromise;
  };

  const getTrigger = (target) =>
    target.closest(".wt-header__search-trigger, .search-results__terms");

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (getTrigger(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    (event) => {
      const trigger = getTrigger(event.target);
      if (!trigger || isReady()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingTrigger) return;
      pendingTrigger = trigger;

      load()
        .then(() => {
          pendingTrigger = null;
          if (trigger.isConnected) trigger.click();
        })
        .catch(() => {
          pendingTrigger = null;
        });
    },
    true,
  );
})();
